import { render } from "./ChartCard.vue?vue&type=template&id=2dc8a12f&scoped=true"
import script from "./ChartCard.vue?vue&type=script&lang=js"
export * from "./ChartCard.vue?vue&type=script&lang=js"

import "./ChartCard.vue?vue&type=style&index=0&id=2dc8a12f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2dc8a12f"

export default script